export const NOTIFICATIONS_FETCH_REQUESTED = 'NOTIFICATIONS_FETCH_REQUESTED';
export const NOTIFICATIONS_FETCH_SUCCEEDED = 'NOTIFICATIONS_FETCH_SUCCEEDED';
export const NOTIFICATIONS_FETCH_FAILED = 'NOTIFICATIONS_FETCH_FAILED';

export const NOTIFICATIONS_PATCH_REQUESTED = 'NOTIFICATIONS_PATCH_REQUESTED';
export const NOTIFICATIONS_PATCH_SUCCEEDED = 'NOTIFICATIONS_PATCH_SUCCEEDED';
export const NOTIFICATIONS_PATCH_FAILED = 'NOTIFICATIONS_PATCH_FAILED';

export const USER_NOTIFICATION = 'USER_NOTIFICATION';
